<template>
  <div class="fixed z-50 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div class="inline-block align-middle bg-white rounded-xl text-left overflow-hidden shadow-2xl transform transition-all w-full sm:w-11/12 md:w-2/3 lg:w-1/2 my-8">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">

          <div class="flex flex-col bg-white rounded p-2 sm:p-6">
            <div class="flex items-center justify-between mb-8 pb-4 border-b border-gray-100">
              <div class="flex items-center gap-2 justify-center flex-1">
                <i class="fas fa-exclamation-circle text-base text-letterbg "></i> <h3 class="text-lg leading-6 font-semibold text-gray-900 text-center" id="modal-title"> Reported Issue  </h3>
              </div>
              <button type="button" class="text-gray-400 hover:text-gray-600 transition-colors" @click="cancelTransaction" aria-label="Close">
                <i class="fas fa-times text-lg"></i>
              </button>
            </div>


            <div class="flex  flex-col space-y-3 text-sm text-gray-900">
              <p>Created: {{date}}</p>
              <p>Ticket Category: {{category}}</p>
              <p>Ticket Status: {{status}}</p>

              <textarea name="" id="" cols="30" rows="10" class="border border-gray-200 rounded-lg w-full bg-white p-2.5 text-sm focus:outline-none focus:border-express" :value="message" disabled></textarea>

            </div>








            <div class="flex flex-col sm:flex-row items-center justify-end gap-3 mt-8 pt-4 border-t border-gray-100">
              <button type="button" class="w-full sm:w-auto inline-flex justify-center rounded-lg px-5 py-2.5 bg-express text-sm font-medium text-white hover:bg-expressbutton transition-colors" @click="cancelTransaction">Dismiss</button>
            </div>





          </div>




        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "customerisssuemodals.vue",
  emits:["completeTransaction","cancelTransaction"],
  props:["category","message","date","status"],
  methods: {
    completeTransaction: function ()  {
      this.$emit('completeTransaction')
    },
    cancelTransaction: function () {
      this.$emit('cancelTransaction')
    }


  }
}
</script>

<style scoped>

</style>
